(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-refresh-datasource', actionFunc);

    function actionFunc(lodash, DatasourceRegistry, $q) {
        return function(options) {
            return $q.when(run());
            function run() {
                if (lodash.get(options, 'panel_id', null) !== null) {
                    DatasourceRegistry.refresh(options.panel_id);
                }
                return true;
            }
        };
    }
})();